import React from "react";
import { PublicShell } from "@/public/PublicChrome";
import { SupportForm } from "@/components/SupportForm";
import Seo from "@/components/Seo";

export default function PublicSupport() {
  return (
    <PublicShell>
      <Seo title="Support — TRADECRAFT" description="Contact TRADECRAFT support." path="/support" noindex={false} />
      <section className="px-6 sm:px-8 pt-28 pb-20">
        <div className="mx-auto max-w-xl" data-testid="support-page">
          <h1 className="font-heading text-4xl sm:text-5xl font-bold text-tc-txt">Support</h1>
          <p className="mt-4 text-sm text-tc-sub">Questions about your account, billing or the product? Send us a message and we'll reply by email.</p>
          <div className="mt-8"><SupportForm idPrefix="support" /></div>
        </div>
      </section>
    </PublicShell>
  );
}
